
import React, { Component } from "react";
import PropTypes from 'prop-types';
import * as style from "./style.scss";
import SimpleBar from 'simplebar-react';
import 'simplebar-react/dist/simplebar.min.css';
import { IdleTimeOutModal } from '../../../utils/IdleModal.js'
import * as signOut from '../../../utils/signOut.js';
import { IdleTimer } from './IdleTimer.js'
/**
 * Organizes the complete layout of the app.
 */
export class AppLayout extends Component {

    static propTypes = {
        header: PropTypes.node,
        leftSideBar: PropTypes.node,
        rightSideBar: PropTypes.node,
        showLeftSideBar: PropTypes.bool,
        showRightSideBar: PropTypes.bool
    }

    static defaultProps = {
        header: null,
        leftSideBar: null,
        rightSideBar: null,
        showLeftSideBar: true,
        showRightSideBar: true
    }

    constructor(props) {
        super(props);
        this.state = {
            showTopHeader: true,
            width: 0,
            height: 0,
            showTopHeaderShadow: false,
            showLeftSideBar: true,
            showRightSideBar: true,
            // timeout
            timeout: 1000 * 60 * 20, // 20 minutes for inactivity timeout
            showModal: false,
            isTimedOut: false
        }
        this.idleTimer = null;
    }

    // timeout
    _onAction = (e) => {
        // console.log('user did something', e)
        this.setState({ isTimedOut: false })
    }

    // timeout
    _onActive = (e) => {
        // console.log('user is active', e)
        this.setState({ isTimedOut: false })
    }

    // timeout
    _onIdle = (e) => {
        // console.log('user is idle', e)
        const isTimedOut = this.state.isTimedOut
        if (isTimedOut) {
            signOut.default();
        } else {
            this.setState({ showModal: true })
            this.setState({ isTimedOut: true })
            // this.idleTimer.reset();
            setTimeout(this._autoSignout, 1000 * 5); // initiate auto logout 5 seconds after modal appears
        }
    }


    _autoSignout = (e) => {
        if (this.state.isTimedOut) {
            signOut.default();
        }
    }

    // timeout (close timeout modal w/o signing out ('stay'))
    handleClose = () => {
        this.setState({ isTimedOut: false }) // will prevent auto timeout
        this.setState({ showModal: false })
        this.idleTimer.reset();
    }

    // timeout
    handleLogout = () => {
        signOut.default();
    }


    updateDimensions = () => {
        this.setState({ width: window.innerWidth, height: window.innerWidth });
        if (window.innerWidth <= 1280) {
            this.setState({
                showLeftSideBar: false,
                showRightSideBar: false
            });
        }

    }

    componentDidMount() {
        window.addEventListener("resize", this.updateDimensions);
        this.updateDimensions();
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.updateDimensions);
    }

    UNSAFE_componentWillReceiveProps(props) {
        if (this.state.showLeftSideBar !== props.showLeftSideBar) {
            this.setState({
                showLeftSideBar: props.showLeftSideBar
            });

        }

        if (this.state.showRightSideBar !== props.showRightSideBar) {
            this.setState({
                showRightSideBar: props.showRightSideBar,
            })
        }

        /*if (window.innerWidth <= 500) {
    
    
                if(this.state.showLeftSideBar){
                    this.setState({
                        showLeftSideBar: false
                    });
                }
                if(this.state.showRightSideBar){
                    this.setState({
                        showRightSideBar: false
                    });
                }
    
        } else {
    
    
            this.setState({
                showLeftSideBar: props.showLeftSideBar,
                showRightSideBar: props.showRightSideBar,
            })
        }*/
    }

    onMainContentScroll = (v) => {
        const { scrollTop } = v;
        if (scrollTop > 0) {
            this.setState({
                showTopHeaderShadow: true
            });
        } else {
            this.setState({
                showTopHeaderShadow: false
            });
        }
    }

    



    render() {
        return (
            <div className={style.appLayout}>
                {this.props.header !== null ? (
                    <AppLayoutHeader shadow={this.state.showTopHeaderShadow}>
                        {this.props.header}
                    </AppLayoutHeader>
                ) : null}
                {this.props.leftSideBar !== null ? (

                    <AppLayoutSideBar position={'left'} show={this.state.showLeftSideBar}>
                        {this.props.leftSideBar}
                    </AppLayoutSideBar>
                ) : null}

                <React.Fragment>

                    <IdleTimer
                        ref={ref => { this.idleTimer = ref }}
                        element={document}
                        onActive={this._onActive}
                        onIdle={this._onIdle}
                        onAction={this._onAction}
                        debounce={250}
                        timeout={this.state.timeout}
                    />

                    <AppLayoutMainContent onScroll={this.onMainContentScroll} sideBarVisible={this.state.showLeftSideBar}>
                        {this.props.children}
                    </AppLayoutMainContent>

                    <IdleTimeOutModal
                        showModal={this.state.showModal}
                        handleClose={this.handleClose}
                        handleLogout={this.handleLogout}
                    />

                </React.Fragment>

                {this.props.rightSideBar !== null ? (
                    <AppLayoutSideBar position={'right'} show={this.state.showRightSideBar}>
                        {this.props.rightSideBar}
                    </AppLayoutSideBar>
                ) : null}


            </div>
        )
    }
}

/**
 * Component that renders the header component for the storm-mobile.
 */
export class AppLayoutHeader extends Component {


    static propTypes = {
        shadow: PropTypes.bool
    }

    static defaultProps = {
        shadow: false
    }

    // COMPONENT Render ................................
    render() {
        return (
            <div className={[style.appLayoutHeader, "shadow"].join(' ')}>
                {this.props.children}
            </div>
        )
    }
}

/**
 * Component that renders the side bar menu in the header.
 */
export class AppLayoutSideBar extends Component {
    static propTypes = {
        position: PropTypes.string
    }

    static defaultProps = {
        position: 'left'
    }

    // COMPONENT Render ................................
    render() {
        return (
            <div
                className={[style.appLayoutSideBar, style[this.props.position], this.props.show ? style.show : null].join(' ')}>
                <SimpleBar 
                    autoHide>
                    <div className={style.container}>
                        {this.props.children}
                    </div>
                    
                </SimpleBar>
                <AppLayoutFooter></AppLayoutFooter>
            </div>
        )
    }
}

export class AppLayoutFooter extends Component {


    static propTypes = {
        shadow: PropTypes.bool
    }

    static defaultProps = {
        shadow: false
    }

    // COMPONENT Render ................................
    render() {
        return (
    <div className={style.appLayoutFooter}>
        <label>Mobile STORM v4.0.2</label>
    </div>
    )
    }
}
/**
 * Renders the scrollbar for storm-mobile.
 */
export class AppLayoutMainContent extends Component {
    constructor(props) {
        super(props)
    }
    scrollBar = React.createRef();
    static propTypes = {
        onScroll: PropTypes.func
    }

    static defaultProps = {
        onScroll: () => {
        }
    }

    scrollBarOnUpdate = (values) => {
        this.props.onScroll(values);

    }

    // COMPONENT Render ................................
    render() {
        return (
            <div className={`${style.appLayoutMainContent} ${this.props.sideBarVisible ? "sideBarVisible": ""}`}>
                <SimpleBar style={{ width: '100%', height: '100%' }}
                    ref={ref => this.scrollBar = ref}
                    autoHide>
                    <div className={style.appLayoutContainer}>
                        {this.props.children}
                    </div>
                </SimpleBar>
            </div>
        )
    }
}

/**
 * Renders the icon for the side bar menu.
 */
export class AppLayoutSideBarMenuIcon extends Component {
    render() {
        return (
            <div className={style.appLayoutSideBarMenuIcon} onClick={this.props.onClick}>
                <div className={style.line} />
                <div className={style.line} />
                <div className={style.line} />
            </div>
        )
    }
}
